import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { SharedConfirmationDialogComponent } from '../../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-attachment-floater',
  templateUrl: './attachment-floater.component.html',
  standalone: true,
  imports: [FormsModule, CommonModule],
  styleUrls: ['../../../../modules/checklist/components/checklist-floater/checklist-floater-action.component.scss'],
})
export class AttachmentFloaterComponent implements OnInit, OnDestroy {
  @Input() selectedItemsArray: any[] = [];
  @Output() selectedItemsEmitter: EventEmitter<{
    type: string;
    selectedItemsArray: Array<any>;
  }> = new EventEmitter();
  subscription = new Subscription();
  @Input() fromSideNav = false;
  constructor(private cd: ChangeDetectorRef, private dialog: MatDialog, private documentService: DocumentService) {}
  ngOnInit(): void {}
  clearSelection(): void {
    this.selectedItemsArray = [];
    this.selectedItemsEmitter.emit({ type: 'clear', selectedItemsArray: this.selectedItemsArray });
    this.cd.detectChanges();
  }
  markComplete() {
    this.selectedItemsEmitter.emit({ type: 'done', selectedItemsArray: this.selectedItemsArray });
    this.cd.detectChanges();
  }
  deleteChecklist(): void {
    this.selectedItemsEmitter.emit({ type: 'deleteAll', selectedItemsArray: this.selectedItemsArray });
    this.cd.detectChanges();
  }

  handleItemsDelete(ids: Array<string>) {
    this.subscription.add(
      this.documentService
        .updateMultipleItemsToSetUpList({
          ids,
          status: 'complete',
        })
        .subscribe((response) => {
          // if(response.status === '')
          this.selectedItemsEmitter.emit({ type: 'deleteAll', selectedItemsArray: this.selectedItemsArray });
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
